import list from '@/pages/admin/list'
import edit from '@/pages/admin/edit'
import add from '@/pages/admin/add'
import editUserInfo from '@/pages/admin/editUserInfo'

const routes = [
  {
    path:'/Users',
    component:list,
    meta:{requiredAuth:true}
  },
  {
    path: '/admin/Edit/:id',
    component:edit,
    meta:{requiredAuth:true}
  },
  {
    path: '/admin/Add',
    component:add,
    meta:{requiredAuth:true}
  },
  {
    path: '/User/Info',
    component:editUserInfo,
    meta:{requiredAuth:true}
  }
]

export default routes;